"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function InsightsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-full">
            <Card className="h-80 animate-pulse border-border bg-muted/20" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="rounded-xl border border-destructive/20 bg-destructive/10 p-6 text-center text-destructive-foreground">
        <p>Unable to load the latest insights at this time.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>No trade insights are currently available. Please check back later.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {posts.map((post, i) => <div key={post.id} data-index={i} className="h-full">
          <Card className="group flex h-full flex-col border-border bg-card transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
            <CardHeader className="pb-4">
              {post.date && <div className="mb-3 font-mono text-sm text-muted-foreground">
                  {new Date(post.date).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric"
            })}
                </div>}
              <CardTitle className="font-serif text-2xl leading-tight text-card-foreground md:text-3xl">
                {post.title}
              </CardTitle>
            </CardHeader>
            <CardContent className="flex-grow">
              <div className="line-clamp-3 text-muted-foreground" dangerouslySetInnerHTML={{
            __html: post.excerpt || ""
          }} />
            </CardContent>
            <CardFooter className="pt-4">
              <Button variant="secondary" asChild className="group/btn w-full sm:w-auto">
                <Link to={post.link || "#"}>
                  Read More
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>)}
    </div>;
}
export default function LatestTradeInsights() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="latest-trade-insights" className="dark bg-background text-foreground px-6 py-24 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center md:text-left">
          <h2 className="mb-4 font-serif text-4xl font-bold text-primary-foreground md:text-5xl">
            Latest Trade Insights
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground md:mx-0">
            Stay updated with the latest news, market trends, and insights from Cosmic EXIM LLC's global trade network.
          </p>
        </div>
        <PostsProvider wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <InsightsConsumer />
        </PostsProvider>
      </div>
    </section>;
}